export default import.meta.ROLLDOWN_FILE_URL_44HFYC1lYEHtBxYF7gnsUA